<template>
    <li class="shrink fr">
        <img :src="require('../../../assets/image/images/floor_return.png')"  @click="$emit('emitBack')" alt="">
        <img v-if="index>10&&($store.state.isManage==1||$store.state.isManage==3)" :src="require('../../../assets/image/images/block_delete.png')" style="margin-left:10px;" @click="delect()" alt="">
    </li>
</template>

<script>
export default {
    name:'detailMenu',
    props:{
        index:String
    },
    data(){
        return{
            isGrouptOpen:false
        }
    },
    methods:{
        handGrouptOpen(){
            this.isGrouptOpen = !this.isGrouptOpen;
        },
         //寻找参数
        getQuery (name) {
            // 正则：[找寻'&' + 'url参数名字' = '值' + '&']（'&'可以不存在）
            let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
            let r = window.location.search.substr(1).match(reg);//substr() 的参数指定的是子串的开始位置和长度
            if (r != null) {
            // 对参数值进行解码
            return decodeURI(r[2]);
            }
            return null;
        },
        //获取上端展示名称
        delect () {
            var _this = this;
            if(_this.index>10){
                _this.$http.get("zciid-deliverable/showPlatformStyle/flow/api/delDetailSign", {
                    appId: _this.$appId,
                    blockId: _this.getQuery('blockId'),
                    sign: _this.index
                }).then(res => {
                    window.location.reload();
                })
            }
        }
    }
}
</script>

<style>
.shrink{margin-right: 8px;display: flex;}
.shrink img{width: 24px !important;object-fit: contain !important;}
.shrink img:hover{cursor: pointer;}
.shrink .r-l{width: 24px; height: 24px; border-radius: 50%; background: url(~@/assets/image/images/icons/icon_detail_r_l.png) no-repeat center center; cursor: pointer; margin-top: 6px; margin-left: 4px;}
.shrink .r-l:hover{background: url(~@/assets/image/images/icons/icon_detail_r_l_dark.png) no-repeat center center;}
.shrink .l-r{width: 24px; height: 24px; border-radius: 50%; background: url(~@/assets/image/images/icons/icon_detail_l_r.png) no-repeat center center; cursor: pointer; margin-top: 6px; margin-right: 4px;}
.shrink .l-r:hover{background: url(~@/assets/image/images/icons/icon_detail_l_r_dark.png) no-repeat center center;}
.shrink .groupt{max-width: 600px; overflow: hidden; height: 36px;}
.shrink .groupt .groupt-inner{ height: 38px;float: left;}
.shrink .groupt a{line-height: 38px; margin: 0 2px; padding: 0 4px; font-size: 14px; overflow: hidden; display: inline-block;}
.shrink .groupt a:hover{color: #0d78cf;}

.shrink .disappear{display: none;}
.fr {
    float: right!important;
}
</style>



// WEBPACK FOOTER //
// src/components/floorBlock/control/detailMenu.vue